import { RuleValidator } from '../types';

export const booleanRules: Record<string, RuleValidator> = {
    boolean: (value: any): boolean => {
        if (value === undefined || value === null || value === '') return true;
        return typeof value === 'boolean' || value === 'true' || value === 'false' || value === 1 || value === 0;
    },

    accepted: (value: any): boolean => {
        if (value === undefined || value === null) return false;
        return value === true || value === 'true' || value === 1 || value === '1' || value === 'yes' || value === 'on';
    }
};